import {
    Decoder,
    field,
    number,
    object,
    string
} from 'json-bouncer'

export interface MessageWithTranslation {
    readonly id: number
    readonly text: string
    readonly translation: string
}

export function messageWithTranslationDecoder(): Decoder<MessageWithTranslation> {
    return object({
        id: field('id', number()),
        text: field('text', string()),
        translation: field('translation', string()),
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/MessageWithTranslation.entity.evolve.ts